<div class="modal-content">
  <bzg-modal-header class="header">
    {{trace.DisplayName}} ({{contentSize}})
    <bzg-button-icon icon="icn-close" (click)="closeModal()"></bzg-button-icon>
  </bzg-modal-header>
  <bzg-modal-content class="content" [ngClass]="screenHeightStyle">
    <div #contentDiv *ngIf="!showLoading" [ngClass]="{'text-wrap': textWrap, 'text-no-wrap': !textWrap}">
      {{contentFile}}
    </div>
    <bz-loading class="bz-trace-node-list__loading" [showLoading]="showLoading" [message]="loadingMessage">
    </bz-loading>
  </bzg-modal-content>
  <bzg-modal-footer class="footer" [ngClass]="{ 'show-end': !showLoadMoreResults || showLoading }">
      <div (click)="loadMore()" [ngClass]="{ 'disabled': showLoading }" *ngIf="showLoadMoreResults && !showLoading" class="footer__load-more">
        {{'TRACE.LOAD_LATER_RESULTS' | translate}}
      </div>
    <div class="footer__buttons">
      <bzg-checkbox *ngIf="isOverflowingX" [(ngModel)]="textWrap">{{'TRACE.ADJUST_TEXT' | translate}}</bzg-checkbox>
      <bzg-button-secondary (click)="closeModal()">{{'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
      <bzg-button-primary icon="icon-download" [disabled]="isDownloading || showLoading" (click)="downloadFile()">{{'TRACE.DOWNLOAD_FILE' | translate}}</bzg-button-primary>
    </div>
  </bzg-modal-footer>
</div>